export const EXTENSION_CHROME =
  'https://chrome.google.com/webstore/detail/xpla-vault-wallet/ocjobpilfplciaddcbafabcegbilnbnb';

export const ANDROID =
  'https://play.google.com/store/apps/details?id=xpla.android';

export const iOS = 'https://apps.apple.com/app/xpla-vault/id1640593143';
